window.onload=function(){var input=document.querySelector('.text_limit_3 input[type="text"]');input.addEventListener("input",function(){this.value=this.value.replace(/[^a-zA-Z]/g,"").slice(0,3)})},document.addEventListener("DOMContentLoaded",function(){var contactButton=document.getElementById("contact-button"),contactFormContainer=document.getElementById("contact-form-container"),contactFormContent=document.getElementById("contact-form-content"),successMessage=document.getElementById("success-message");contactButton.addEventListener("click",function(){contactFormContainer.classList.toggle("hidden")}),successMessage&&contactFormContent.classList.add("hidden")});
//# sourceMappingURL=/s/files/1/0863/2182/4063/t/7/assets/custom.js.map?v=1726570478




// Watch for product media changes
const mediaContainer = document.querySelector('.product__media-container');

if (mediaContainer) {
  const observer = new MutationObserver(() => {
    const container = document.querySelector('.product__media-container .swiper');
    if (container && !container.classList.contains('swiper-initialized')) {
      // Kill old instance if somehow still there
      if (container.swiper) {
        container.swiper.destroy(true, true);
      }

      // Re-init Swiper
      new Swiper(container, {
        loop: true,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
      });
    }
  });

  observer.observe(mediaContainer, { childList: true, subtree: true });
}








